import React from "react";
import { Link } from "react-router-dom";

interface AdminDropdownMenuProps {
  onSignOut: () => void;
}

const AdminDropdownMenu: React.FC<AdminDropdownMenuProps> = ({ onSignOut }) => {
  return (
    <div className="w-56 bg-gray-800 text-white rounded-lg shadow-md p-4">
      <nav className="flex flex-col space-y-2 text-sm">
        {/* DASHBOARD */}
        <Link
          to="/admin"
          className="font-semibold mb-1 hover:text-yellow-400 transition duration-300"
        >
          Admin Dashboard
        </Link>

        {/* PUBLIC SITE CONTENT */}
        <div className="mt-2 text-xs uppercase tracking-wide text-gray-400">
          Public Site Content
        </div>
        <Link
          to="/admin/manage-about-us"
          className="hover:text-yellow-400 transition duration-300"
        >
          Manage About Us
        </Link>
        <Link
          to="/admin/manage-blog"
          className="hover:text-yellow-400 transition duration-300"
        >
          Manage Blog
        </Link>
        <Link
          to="/admin/manage-quotes"
          className="hover:text-yellow-400 transition duration-300"
        >
          Manage Quotes
        </Link>

        {/* PRODUCTS & LAB RESULTS */}
        <div className="mt-3 text-xs uppercase tracking-wide text-gray-400">
          Products & Lab Results
        </div>
        <Link
          to="/admin/manage-products"
          className="hover:text-yellow-400 transition duration-300"
        >
          Manage Products
        </Link>
        <Link
          to="/admin/manage-coa"
          className="hover:text-yellow-400 transition duration-300"
        >
          Manage COA / Test Results
        </Link>

        {/* EMAIL & SUBSCRIBERS */}
        <div className="mt-3 text-xs uppercase tracking-wide text-gray-400">
          Email & Subscribers
        </div>
        <Link
          to="/admin/create-update"
          className="hover:text-yellow-400 transition duration-300"
        >
          Email Campaigns
        </Link>
        <Link
          to="/admin/manage-lists"
          className="hover:text-yellow-400 transition duration-300"
        >
          Manage Lists
        </Link>
        <Link
          to="/admin/manage-subscribers"
          className="hover:text-yellow-400 transition duration-300"
        >
          Manage Subscribers
        </Link>

        {/* ADMIN TOOLS */}
        <div className="mt-3 text-xs uppercase tracking-wide text-gray-400">
          Admin Tools
        </div>
        <Link
          to="/admin/contacts"
          className="hover:text-yellow-400 transition duration-300"
        >
          Visitor Contacts
        </Link>
        <Link
          to="/admin/invite-admin"
          className="hover:text-yellow-400 transition duration-300"
        >
          Invite Admin
        </Link>
        <Link
          to="/admin/manage-admin"
          className="hover:text-yellow-400 transition duration-300"
        >
          Manage Admins / Permissions
        </Link>

        {/* SIGN OUT */}
        <button
          onClick={onSignOut}
          className="w-full bg-red-500 hover:bg-red-600 text-white font-bold py-2 rounded-lg mt-4 transition duration-300"
        >
          Sign Out
        </button>
      </nav>
    </div>
  );
};

export default AdminDropdownMenu;
